import React from 'react';
import { containsHtml, sanitizeHtml } from './sanitize';

type HtmlOrTextProps = {
  content: string;
  className?: string;
};

/**
 * Renders API content that may be either plain text or HTML.
 * HTML is sanitized before injection; plain text is rendered as children.
 */
const HtmlOrText: React.FC<HtmlOrTextProps> = ({ content, className }) => {
  if (containsHtml(content)) {
    return (
      <div
        className={className}
        dangerouslySetInnerHTML={{ __html: sanitizeHtml(content) }}
      />
    );
  }

  return <div className={className}>{content}</div>;
};

export default HtmlOrText;
